import { Cell } from 'react-table'
import Icon from '@mdi/react'
import { mdiCircle, mdiCircleOutline, mdiPowerPlug } from '@mdi/js'

import { Circuit, SmartHardware } from 'features/home/types'
import { ChannelCellWrapper } from '../styles'
import theme from 'theme_'

export const ChannelCell = (
  cell: Cell<SmartHardware & Circuit>,
  dual: boolean
) => {
  const icon = () => {
    switch (cell?.value) {
      case 0:
        return (
          <Icon
            path={mdiCircleOutline}
            size={0.75}
            color={theme.colors.horizonOrange}
          />
        )
      case 1:
        return (
          <Icon
            path={mdiCircle}
            size={0.75}
            color={theme.colors.successGreen}
          />
        )
      case 2:
        return (
          <Icon
            path={mdiPowerPlug}
            size={0.75}
            color={theme.colors.otterWarmBlack}
          />
        )
      default:
        return (
          <Icon path={mdiPowerPlug} size={0.75} color={theme.colors.white} />
        )
    }
  }

  const getChannel = (hwUID: string, modelID: number, slot: number) => {
    if (dual) {
      if (slot % 2 === 0 && modelID !== 2 && modelID !== 6 && modelID !== 8) {
        return parseInt(hwUID, 16) % 2 === 0 ? 'A' : 'B'
      }
      return parseInt(hwUID, 16) % 2 === 0 ? 'B' : 'A'
    } else {
      return parseInt(hwUID, 16) % 2 === 0 ? 'B' : 'A'
    }
  }

  return (
    <ChannelCellWrapper>
      {icon()}{' '}
      {cell?.row?.original?.hwUID
        ? getChannel(
            cell?.row?.original?.hwUID,
            cell.row.original.olaConfig.DeviceModelID,
            cell.row.original.olaConfig.SlotNumber
          )
        : '-'}
    </ChannelCellWrapper>
  )
}
